<template>
    <!-- This is replaced by brekz-header.tpl -->
    <slot :ui="ui" :uiTabActive="uiTabActive" />
</template>

<script>
    import HeaderNavCategories from './HeaderNavCategories'
    import AlgoliaSearchInput from "./Algolia/AlgoliaSearchInput";
    import AlgoliaSearchInputMobile from "./Algolia/AlgoliaSearchInputMobile";
    import AutoComplete from "./Algolia/Autocomplete/AutoComplete.vue";

    const MENU_MODE_OFFSET = 100;

    export default {
        components: {
            HeaderNavCategories,
            AlgoliaSearchInput,
            AutoComplete,
            // AlgoliaSearchInputMobile,
        },
        data() {
            return {
                ui: {
                    menuIsAlternativeMode: false,
                    searchActive: false
                },
                uiTabActive: {
                    key: null
                },
            };
        },
        created() {

            window.EventBus.$on('search-opened', () => {
                this.ui.searchActive = true;
            });

            window.EventBus.$on('search-closed', () => {
                this.ui.searchActive = false;
            });
            window.EventBus.$on('uiTabActiveChild',(args) => {
                this.uiTabActive.key = args;
            });
        },
        methods: {
            closeMenu() {
                window.EventBus.$emit('close-menu');
            }
        },
    };
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
